export default __webpack_public_path__ + "static/media/tip.64a6d47c.png";